import { render } from "./packagesTable.vue?vue&type=template&id=3f98b584"
import script from "./packagesTable.vue?vue&type=script&lang=js"
export * from "./packagesTable.vue?vue&type=script&lang=js"

import "./packagesTable.vue?vue&type=style&index=0&id=3f98b584&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__